import React from "react";
import NotFoundContainer from "../containers/not-found-container";

export default class NotFoundPage extends React.Component {
  render() {
    return (
      <main className="not-found-page">
        <NotFoundContainer />
      </main>
    );
  }
}
